<script>
  // Props for customization
  export let size = 29;

  // Additional props to pass to the SVG element
  let className = "";
  export { className as class };
  export let style = "";
  export let title = null;

  // Calculate viewBox based on the original SVG
  const viewBox = "0 0 29 29"; // Replace with your icon's actual viewBox
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={size}
  height={size}
  {viewBox}
  fill="none"
  stroke-width="0"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden={title ? null : true}
  aria-labelledby={title ? "title" : null}
  class={className}
  {style}
  {...$$restProps}
>
  {#if title}
    <title id="title">{title}</title>
  {/if}
  <path
    d="M12.5461 6.8295L11.3789 5.858C11.0533 5.58648 10.6428 5.43769 10.2189 5.4375H3.625C3.1443 5.4375 2.68328 5.62846 2.34337 5.96837C2.00346 6.30828 1.8125 6.7693 1.8125 7.25V21.75C1.8125 22.2307 2.00346 22.6917 2.34337 23.0316C2.68328 23.3715 3.1443 23.5625 3.625 23.5625H25.375C25.8557 23.5625 26.3167 23.3715 26.6566 23.0316C26.9965 22.6917 27.1875 22.2307 27.1875 21.75V9.0625C27.1875 8.58179 26.9965 8.12078 26.6566 7.78087C26.3167 7.44096 25.8557 7.25 25.375 7.25H13.7061C13.2822 7.24981 12.8717 7.10102 12.5461 6.8295Z"
    fill="#3F15E5"
  />
  <path
    d="M24.7896 18.9143L29 22.9671L26.5169 25.3451L22.3363 21.2933V20.6253L24.1008 18.9143H24.7896ZM25.4702 17.081L24.7452 16.385L21.1627 19.8641V21.2933L16.9523 25.375L14.5 22.9671L18.6796 18.9143H20.1532L20.7368 18.3488L17.864 15.5576H16.8934L14.7909 13.4995L16.7502 11.6L18.8446 13.63V14.5797L21.7536 17.3637L23.7419 15.4352L23.0251 14.703L23.9966 13.7523H22.0065L21.5207 13.2811L23.9975 10.875L24.4914 11.3526V13.282L25.4711 12.3241L27.9243 14.703C28.1172 14.8905 28.2706 15.1148 28.3753 15.3626C28.48 15.6104 28.534 15.8767 28.534 16.1458C28.534 16.4148 28.48 16.6811 28.3753 16.9289C28.2706 17.1767 28.1172 17.401 27.9243 17.5885L26.4498 16.1303L25.4702 17.081Z"
    fill="#BBDEFB"
  />
</svg>
